import React, { useState } from 'react'
//import { Link } from 'react-router-dom'
import { unitActions } from '../../action/unitaction';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import 'bootstrap';
import Modal from 'bootstrap/js/dist/modal';

const AddUnit = ({ onSuccess }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        unit_name: '',
        short_name: '',
        no_of_products:'',
        status: true
    });
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : 
                type === 'number' ? (value === '' ? '' : Number(value)) : 
                value
    }));
   };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!formData.unit_name.trim()) {
            Swal.fire('Error', 'Please enter unit name', 'error');
            return;
        }
        
        if (!formData.short_name.trim()) {
            Swal.fire('Error', 'Please enter short name', 'error');
            return;
        }
        // Fix: Check if no_of_products is empty or invalid
            if (formData.no_of_products === '' || formData.no_of_products == null) {
                Swal.fire('Error', 'Please enter No of Product', 'error');
                return;
            }
        
            // Optional: Validate it's a number
            if (isNaN(formData.no_of_products) || Number(formData.no_of_products) < 0) {
                Swal.fire('Error', 'Please enter a valid number for No of Products', 'error');
                return;
            }
        
        setLoading(true);
        try {
             // Ensure no_of_products is a number when sending to API
        const payload = {
            ...formData,
            no_of_products: Number(formData.no_of_products) // Convert to number
        };
        
            await dispatch(unitActions.createUnit(payload));
            
            // Reset form
            setFormData({
                unit_name: '',
                short_name: '',
                no_of_products:'',
                status: true
            });
            
            // Close modal
            const modal = document.getElementById('add-units');
            const modalInstance = Modal.getInstance(modal) || new Modal(modal);
            modalInstance.hide();
            // Cleanup any leftover backdrops and body class that can remain when closing programmatically
            setTimeout(() => {
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                document.body.classList.remove('modal-open');
            }, 200);
            
            // Refresh unit list
            if (onSuccess) onSuccess();
            
        } catch (error) {
            console.error('Error creating unit:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {/* Add Unit */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Create Unit</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="unit_name"
                                                value={formData.unit_name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Short Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                name="short_name"
                                                value={formData.short_name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
    <label className="form-label">No of Products</label>
    <input
        type="number"  // Change to number type
        className="form-control"
        name="no_of_products"
        value={formData.no_of_products}
        onChange={handleInputChange}
        min="0"  // Optional: prevent negative numbers
        required
    />
</div>
                                        <div className="mb-0">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Status</span>
                                                <input
                                                    type="checkbox"
                                                    id="user2"
                                                    className="check"
                                                    checked={formData.status}
                                                    onChange={handleInputChange}
                                                    name="status"
                                                />
                                                <label htmlFor="user2" className="checktoggle" />
                                            </div>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                disabled={loading}
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                type="submit" 
                                                className="btn btn-submit"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Creating...
                                                    </>
                                                ) : 'Create Unit'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Unit */}
        </div>
    )
}

AddUnit.propTypes = {
    onSuccess: PropTypes.func
};

export default AddUnit